export default __webpack_public_path__ + "static/Денежный поток 303+404_3-89ba325d81af57910f2beab1041841eb.jpg";